import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardHeader, CircularProgress, Hidden, Typography, useTheme } from '@material-ui/core';
import { getInsumosMaisUsados } from '../../../../../services/DashboardService';
import Chart from 'react-apexcharts';
import { IOSSwitch } from '../../../../../components/';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import Dialog from '@material-ui/core/Dialog/Dialog';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import ListItemAvatar from '@material-ui/core/ListItemAvatar/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 20,
    maxHeight: 550,
    minHeight: 550
  },
  chartContainer: {
    minHeight: 350,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const GraficoInsumosMaisUsados = props => {
  const { className, ...rest } = props;
  const theme = useTheme();
  const [modalidadesMaisUsadas, setModalidadesMaisUsadas] = useState([]);
  const [mostrarProgress, setMostrarProgress] = useState(true);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);
  const [labels, setLabels] = useState([]);
  const [valores, setValores] = useState([]);
  const [mostrarAnaliseDetalhada, setMostrarAnaliseDetalhada] = useState(true);
  let [totalInsumos, setTotalInsumos] = useState(0);
  let [dadosTodosInsumos, setDadosTodosInsumos] = useState([]);
  let [abrirDialogDetalhes, setAbrirDialogDetalhes] = useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));


  const classes = useStyles();

  useEffect(() => {
    try {
      getDados();
    }
    catch (e) {

    }
  }, []);

  async function getDados() {
    try {
      setMostrarProgress(true);
      let dados = await getInsumosMaisUsados();
      if (dados.isSuccess) {
        setMostrarProgress(false);
        setModalidadesMaisUsadas(dados.result.lideres);
        let novasLabels = [];
        let novosValores = [];
        dados.result.lideres.map(insumo => {
          novasLabels.push(insumo.descricao);
          novosValores.push(parseFloat(insumo.totalInsumo ? insumo.totalInsumo : 0));
        });
        dados.result.dados.map(insumo => {
          totalInsumos += insumo.totalInsumo ? parseFloat(insumo.totalInsumo) : 0;
        });
        setDadosTodosInsumos(dados.result.dados);
        setTotalInsumos(totalInsumos);
        setLabels(novasLabels);
        setValores(novosValores);

      } else {
        setMostrarProgress(false);
        setMostrarAlertaErro(true);
      }
    } catch (e) {
      setMostrarProgress(false);
      setMostrarAlertaErro(true);
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      elevation={3}
    >
      <Dialog
        fullScreen={fullScreen}
        open={abrirDialogDetalhes}
        aria-labelledby="form-dialog-title"
        fullWidth
        onClose={e => { setAbrirDialogDetalhes(false) }}
        TransitionComponent={Transition}
      >
        <DialogContent>
          <Grid
            container
            spacing={2}
            justify={'space-between'}
          >
            <Grid
              item
              md={12}
              xs={12}
            >
              <List>
                {
                  dadosTodosInsumos.map((insumo, index) => {
                    return (
                      <ListItem
                        key={index}
                      >
                        <ListItemAvatar>
                          <Avatar
                          >
                            <DoubleArrowIcon/>
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          id={index}
                          primary={insumo.descricao}
                        />
                        <ListItemSecondaryAction>
                          <ListItemText
                            primary={insumo.totalInsumo}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                    );
                  })
                }
              </List>
            </Grid>
            <Grid
              item
              md={12}
              xs={12}
            >
              <Divider variant="fullWidth" />
            </Grid>
            <Grid
              item
              md={3}
              xs={3}
              style={{
                display: 'flex',
                justifyContent: 'left'
              }}
            >
              <Typography
                variant="h6"
                color="textPrimary"

              >
                TOTAL:
              </Typography>
            </Grid>
            <Grid
              item
              md={9}
              xs={9}
              style={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Typography
                variant="h6"
                color="textPrimary"
              >
                { totalInsumos }
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <CardHeader
        title="Insumos mais usados"
      />
      <CardContent
      >
        <Grid
          container
        >
          {
            mostrarProgress &&
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center',
                height: 400
              }}
            >
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  height: 400,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <div className={classes.chartContainer}>
                  <CircularProgress
                  />
                </div>
              </Grid>
            </Grid>
          }
          {
            !mostrarProgress &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <div className={classes.chartContainer}>
                <Chart
                  options={{
                    chart: {
                      height: 280,
                      type: 'pie',
                    },
                    dataLabels: {
                      enabled: true
                    },
                    responsive: [{
                      options: {
                        legend: {
                          show: true
                        }
                      }
                    }],

                    legend: {
                      position: 'top',
                    },
                    labels: labels,
                    colors: [theme.palette.primary.main, theme.palette.info.main, theme.palette.success.main, theme.palette.warning.main, theme.palette.error.main]
                  }}
                  type={'pie'}
                  series={valores}
                  height={280}
                />
              </div>
            </Grid>
          }
          {
            !mostrarProgress &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
                variant="body2"
              >
                Observação: Os valores mostrados no gráfico representam as quantidades de uso dos insumos em todas as visitas. Ou seja,
                a quantidade de disparos realizados em cada insumo.

              </Typography>
            </Grid>
          }
          {
            !mostrarProgress &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <Button
                variant={'outlined'}
                fullWidth
                onClick={e => setAbrirDialogDetalhes(true)}
              >
                VER MAIS
              </Button>

            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

GraficoInsumosMaisUsados.propTypes = {
  className: PropTypes.string
};

export default GraficoInsumosMaisUsados;
